export default function migrateWeapon(weapon) {
  // Add new "nameUnique" property.
  weapon.nameUnique = weapon?.nameUnique || weapon.name
  return weapon
}
